import { FC } from 'react';
import GooglePicker from 'react-google-picker';
import { initGoogleKeys } from '../../../helpers/external-tools-helper';

export const GoogleDrivePicker: FC = ({ children }) => {
  const googleCredential = initGoogleKeys();
  return (
    <GooglePicker {...googleCredential} multiselect>
      {children ?? ' '}
    </GooglePicker>
  );
};
